module.exports = __webpack_public_path__ + "img/xing.feb47907.png";